<script lang="ts" setup>
interface Props {
  direction?: 'row' | 'column';
}

const props = withDefaults(defineProps<Props>(), {
  direction: 'column',
});

const variantClasses = computed(() => {
  return twMerge(
    cva('', {
      variants: {
        direction: {
          row: 'flex-row',
          column: 'flex-col',
        },
      },
    })({
      direction: props.direction,
    }),
  );
});
</script>

<template>
  <div :class="variantClasses" class="flex h-full flex-1 items-center justify-center">
    <slot />
  </div>
</template>
